import {ReactNode} from 'react'

import './IconTitle.scss'
import Text from 'common/components/typography/Text'

interface IconTitleProps {
  children: ReactNode
  icon: JSX.Element
  mb?: number
}

export default function IconTitle({children, icon, mb}: IconTitleProps) {
  return (
    <Text as="h4" className="IconTitle" weight="demiBold" mb={mb}>
      <div className="IconTitle-Icon">{icon}</div>
      <span>{children}</span>
    </Text>
  )
}
